import type {PredictionResult} from "modules/enums";
import type {ILoadMoreAction, TLoadMoreResponse} from "modules/types";
import {createAction} from "redux-act";

interface IAddPlayerAction {
	playerId: number;
	unitId: number;
}

export const addPlayer = createAction<IAddPlayerAction>();

interface IRemovePlayer {
	roundId: number;
}

export const removePlayers = createAction<IRemovePlayer>();

interface IMatchResults {
	atBats: number | null;
	hits: number | null;
	playerId: number | null;
	result: PredictionResult | null;
	sacFlies: number | null;
	streak: number | null;
}

export interface IPrediction {
	roundId: number;
	unitId: number;
	playerId: number;
	number: number;
	result: PredictionResult | null;
	streak: number | null;
	matchPlayerResults?: IMatchResults;
}

export const removePick = createAction<IPrediction>();

interface IPredictionsApiResponse {
	predictions: IPrediction[];
	resentHistory: IPrediction[];
}

export const getPredictionsAPISuccess = createAction<IPredictionsApiResponse>();

type TPutPredictionsToStoreType = ReturnType<typeof getPredictionsAPISuccess>["payload"] &
	ReturnType<typeof fetchPredictions>["payload"];

export const getPredictionsPutStoreSuccess = createAction<TPutPredictionsToStoreType>();

interface IHistoryApiResponse {
	predictions: IPrediction[];
}

export const getHistoryAPISuccess = createAction<TLoadMoreResponse<IHistoryApiResponse>>();

interface IFetchPredictionsPayload {
	roundId: number;
}

export const fetchPredictions = createAction<IFetchPredictionsPayload>();

export const clearPicksHistory = createAction();
export const fetchPicksHistory = createAction<ILoadMoreAction>();

export const fetchFriendPicks = createAction<ILoadMoreAction>();

interface IHistory {
	userId: number;
	username: string;
	avatar: string | null;
	roundId: number;
	streak: number | null;
	result: PredictionResult | null;
	levelColor: string | null;
	predictions: {
		number: number;
		unitId: number;
		playerId: number;
		result: PredictionResult | null;
	}[];
}

export const fetchFriendPicksSuccess = createAction<TLoadMoreResponse<{history: IHistory[]}>>();
export const fetchFriendPicksFailed = createAction();

export const fetchFriendPicksByPlayer = createAction<{
	unitId: number;
	playerId: number;
}>();

interface IFriendPick {
	userId: number;
	username: string;
	avatar: string | null;
}

export const fetchFriendPicksByPlayerSuccess = createAction<{friends: IFriendPick[]}>();

export const fetchFriendPicksByPlayerPutSuccess = createAction<
	ReturnType<typeof fetchFriendPicksByPlayer>["payload"] &
		ReturnType<typeof fetchFriendPicksByPlayerSuccess>["payload"]
>();

export const toggleMulliganModal = createAction();
export const hideMulliganModal = createAction();

export const setInsightsViewState = createAction<boolean>();
